module.exports = __webpack_public_path__ + "static/media/landscape-background.3f7555a0.jpg";